var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_US/internet/index.js
 ** module id = 551
 ** module chunks = 0
 **/